export const SIDEBAR_KEYS = {
  MAIN: "main",
  MAIN_DIVIDER: "main-divider",
  SMART_DEVICES: "smart-devices",
  ALARMS: "alarms",
  SMART_DEVICES_DIVIDER: "smart-devices-divider",
  GENERATION: "generation",
  PREDICTION: "prediction",
  PREDICTION_DIVIDER: "prediction-divider",
  TOOLS: "tools",
  TOOLS_DIVIDER: "tools-divider",
  DOCUMENTS: "documents",
  DOCUMENTS_DIVIDER: "documents-divider",
  ADMINISTRATION: "administration",
};
